import { createAction, props } from '@ngrx/store';
import { ReCaptcha } from '../../recaptcha/model/ReCaptcha';

export const InitializeReCaptcha = createAction(
  '[Shared][ReCaptcha] Initialize'
);

export const ValidateReCaptcha = createAction(
  '[Shared][ReCaptcha] Validate',
  props<{ reCaptcha: ReCaptcha }>()
);

export const ValidatedReCaptcha = createAction(
  '[Shared][ReCaptcha] Validated',
  props<{ success: boolean }>()
);

export const ValidateReCaptchaError = createAction(
  '[Shared][ReCaptcha] Validate Error',
  props<{ errorMessage: string }>()
);
